<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-user-view">
		<vs-alert color="danger" :title="$t('VisitPoints.VisitPointNotFound.Title')" :active.sync="vp_not_found">
			{{
				$t("VisitPoints.VisitPointNotFound.Text1") +
				" " +
				$route.params.id +
				" " +
				$t("VisitPoints.VisitPointNotFound.Text2")
			}}
			<span>
				<span>{{ $t("Check") }} </span>
				<router-link :to="{name: 'app-visit-point-list'}" class="text-inherit underline">{{
					$t("VisitPoints.ListVisitPoint")
				}}</router-link>
			</span>
		</vs-alert>
		<div id="user-data" v-if="visitPointData">
			<vx-card :title="$t('Information')" class="mb-base">
				<div class="vx-row">
					<div class="vx-col flex-1" id="account-info-col-1">
						<table>
							<caption></caption>
							<thead>
								<tr>
									<th scope="col"></th>
								</tr>
							</thead>
							<tr>
								<td class="font-semibold">{{ $t("Routing.Table.Identification") }}</td>
								<td>{{ visitPointData.identification }}</td>
							</tr>
						</table>
					</div>

					<div class="vx-col flex-1" id="account-info-col-2">
						<table>
							<caption></caption>
							<thead>
								<tr>
									<th scope="col"></th>
								</tr>
							</thead>
							<tr>
								<td class="font-semibold">{{ $t("Priority") }}</td>
								<td>{{ visitPointData.priority }}</td>
							</tr>
							<tr>
								<td class="font-semibold">{{ $t("TypeConfig.Form.Status") }}</td>
								<td>{{ visitPointData.status_name }}</td>
							</tr>
						</table>
					</div>

					<div class="vx-col w-full flex mt-base justify-end" id="account-manage-buttons">
						<vs-button
							type="border"
							icon-pack="feather"
							icon="icon-edit"
							class="mr-4"
							color="success"
							:title="windowWidth > 620 ? null : $t('Crud.Update')"
							:size="iconSize"
							:to="{
								name: 'app-visit-point-edit',
								params: {id: $route.params.id},
							}"
							>{{ windowWidth > 620 ? $t("Crud.Update") : null }}
						</vs-button>
						<vs-button
							type="border"
							color="danger"
							icon-pack="feather"
							icon="icon-trash"
							class="mr-4"
							:title="windowWidth > 620 ? null : $t('Crud.Delete')"
							:size="iconSize"
							@click="confirmDeleteRecord"
							>{{ windowWidth > 620 ? $t("Crud.Delete") : null }}
						</vs-button>
						<vs-button
							type="border"
							color="primary"
							icon-pack="feather"
							icon="icon-list"
							:title="windowWidth > 620 ? null : $t('Routing.Title.VisitPointsList')"
							:size="iconSize"
							:to="{name: 'app-visit-point-list'}"
							>{{ windowWidth > 620 ? $t("Routing.Title.VisitPointsList") : null }}
						</vs-button>
					</div>
				</div>
				<vs-divider class="mt-base mb-base"></vs-divider>
				<template lang="html">
					<vs-tabs>
						<vs-tab :label="$t('VisitPoints.Location') | capitalize" icon-pack="feather" icon="icon-info">
							<vx-card card-border no-shadow class="mb-base mt-base">
								<table>
									<caption></caption>
									<thead>
										<tr>
											<th scope="col"></th>
										</tr>
									</thead>
									<tr>
										<td class="font-semibold">{{ $t("Address") }}</td>
										<td>{{ visitPointData.address }}</td>
									</tr>
									<tr>
										<td class="font-semibold">{{ $t("Divipola.Country") }}</td>
										<td>{{ visitPointData.country }}</td>
									</tr>
									<tr>
										<td class="font-semibold">{{ $t("Divipola.Department") }}</td>
										<td>{{ visitPointData.department }}</td>
									</tr>
									<tr>
										<td class="font-semibold">{{ $t("Divipola.City") }}</td>
										<td>{{ visitPointData.city }}</td>
									</tr>
									<tr>
										<td class="font-semibold">{{ $t("Routing.Table.Longitude") }}</td>
										<td>{{ visitPointData.cx }}</td>
									</tr>
									<tr>
										<td class="font-semibold">{{ $t("Routing.Table.Latitude") }}</td>
										<td>{{ visitPointData.cy }}</td>
									</tr>
								</table>
							</vx-card>
						</vs-tab>
						<vs-tab :label="$t('AdditionalFields') | capitalize" icon-pack="feather" icon="icon-file-plus">
							<vx-card no-shadow card-border class="mb-base mt-base">
								<table
									v-if="
										visitPointData.additional_info &&
										Object.keys(visitPointData.additional_info).length > 0
									"
								>
									<caption></caption>
									<thead>
										<tr>
											<th scope="col"></th>
										</tr>
									</thead>
									<tr v-for="(value, label) in visitPointData['additional_info']" :key="label">
										<td class="font-semibold">{{ label | capitalize }}</td>
										<td>{{ value }}</td>
									</tr>
								</table>
								<vs-alert v-else active class="mb-5" color="primary">
									<span>
										{{ $t("NotAdditionalFields") }}
									</span>
								</vs-alert>
							</vx-card>
						</vs-tab>
						<vs-tab
							:label="$t('Skills.AssignedSkills') | capitalize"
							icon-pack="feather"
							icon="icon-award"
							class="mb-base mt-base"
						>
							<assigned-skill-list
								v-if="skillsIds.length > 0"
								:skillListIds="skillsIds"
								:customConfig="skillListConfig"
							/>
							<vx-card v-else no-shadow card-border>
								<vs-alert active class="mb-5" color="primary">
									<span> {{ $t("Skills.NoSkillsAssigned") }} </span>
								</vs-alert>
							</vx-card>
						</vs-tab>
						<vs-tab
							:label="$t('Capacity.AssignedCapacities') | capitalize"
							icon-pack="feather"
							icon="icon-box"
							class="mb-base mt-base"
						>
							<assigned-capacity-list
								v-if="capacityIds.length > 0"
								:is-demand="true"
								:is-type-service="true"
								:capacities="visitPointData.capacities"
								:capacityListIds="capacityIds"
								:navbarOptions="false"
								:columns="columnsCapacity"
								:defaultColumns="defaultColumnsCapacity"
							/>
							<vx-card v-else no-shadow card-border>
								<vs-alert active class="mb-5" color="primary">
									<span> {{ $t("Capacity.NoAssignedCapacities") }} </span>
								</vs-alert>
							</vx-card>
						</vs-tab>
						<vs-tab
							:label="$t('TimeWindow.AssignedTimeWindows') | capitalize"
							icon-pack="feather"
							icon="icon-clock"
							class="mb-base mt-base"
						>
							<assigned-time-window-list
								v-if="timeWindowIds.length > 0"
								:configColumns="false"
								:remove="false"
								:redirect="true"
								:time_window_ids="timeWindowIds"
							/>
							<vx-card v-else no-shadow card-border>
								<vs-alert active class="mb-5" color="primary">
									<span> {{ $t("TimeWindow.NoAssignedTimeWindows") }} </span>
								</vs-alert>
							</vx-card>
						</vs-tab>
						<vs-tab
							:label="$t('Frequency.AssignedFrequencies') | capitalize"
							icon-pack="feather"
							icon="icon-radio"
							class="mb-base mt-base"
						>
							<assigned-frequency-list
								v-if="frequencyIds.length > 0"
								:navbarOptions="false"
								:frequencyIds="frequencyIds"
								:redirect="true"
								:remove="false"
								:configColumns="false"
							/>
							<vx-card v-else no-shadow card-border>
								<vs-alert active class="mb-5" color="primary">
									<span> {{ $t("Frequency.NoAssignedFrequencies") }} </span>
								</vs-alert>
							</vx-card>
						</vs-tab>
					</vs-tabs>
				</template>
			</vx-card>
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";
import "swiper/dist/css/swiper.min.css";
import {swiper, swiperSlide} from "vue-awesome-swiper";
import AssignedCapacityList from "@/components/capacity/AssignedCapacityList.vue";
import AssignedSkillList from "@/components/skills/AssignedSkillList.vue";
import AssignedTimeWindowList from "@/components/time-window/list/AssignedTimeWindowList.vue";
import AssignedFrequencyList from "@/components/frequency/list/AssignedFrequencyList.vue";
import moduleCapacity from "@/store/capacity/moduleCapacity.js";
import moduleSkills from "@/store/skills/moduleSkills.js";
import moduleTimeWindow from "@/store/time-window/moduleTimeWindow.js";

export default {
	components: {
		vSelect,
		swiper,
		swiperSlide,
		AssignedCapacityList,
		AssignedSkillList,
		AssignedTimeWindowList,
		AssignedFrequencyList,
	},
	data() {
		return {
			visitPointData: null,
			vp_not_found: false,
			columnsCapacity: ["name", "description"],
			defaultColumnsCapacity: ["name", "description"],
			skillListConfig: {
				rowSelection: "multiple",
				activeCheckbox: true,
				activeHeaderCheckboxSelection: true,
				activeLink: false,
				columns: ["id", "name", "description", "identifier"],
				defaultColumns: ["id", "name", "description", "identifier"],
				tableOptions: false,
				showItemsPerPage: false,
				showSearch: false,
				showActions: false,
				navbarOptions: false,
			},
		};
	},
	computed: {
		capacityIds() {
			return this.visitPointData["capacities"] && this.visitPointData["capacities"] !== null
				? this.visitPointData["capacities"].map(({capacity_id}) => capacity_id)
				: [];
		},
		skillsIds() {
			return this.visitPointData["skill_id"] && this.visitPointData["skill_id"] !== null
				? this.visitPointData["skill_id"]
				: [];
		},
		timeWindowIds() {
			return this.visitPointData["time_window_id"] && this.visitPointData["time_window_id"] !== null
				? this.visitPointData["time_window_id"]
				: [];
		},
		frequencyIds() {
			return this.visitPointData["repeat_frequency_id"] && this.visitPointData["repeat_frequency_id"] !== null
				? this.visitPointData["repeat_frequency_id"]
				: [];
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		confirmDeleteRecord() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: `${this.$t("VisitPoints.YouAreAboutToDeleteTheVisitPoint")} "${
					this.visitPointData.identification
				}"`,
				accept: this.deleteRecord,
				acceptText: this.$t("Crud.Delete"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteRecord() {
			/* Below two lines are just for demo purpose */
			this.$store
				.dispatch("moduleVisitPoint/deleteById", this.visitPointData.id)
				.then((res) => {
					this.$router.push({name: "app-visit-point-list"});
					this.showDeleteSuccess();
				})
				.catch((err) => {
					if (err.response.status === 404) {
						return;
					}
				});
		},
		showDeleteSuccess() {
			this.$vs.notify({
				color: "success",
				title: this.$t("VisitPoints.CellRenderer.DeleteSuccess.Title"),
				text: this.$t("VisitPoints.CellRenderer.DeleteSuccess.Text"),
			});
		},
	},
	created() {
		if (!moduleCapacity.isRegistered) {
			this.$store.registerModule("moduleCapacity", moduleCapacity);
			moduleCapacity.isRegistered = true;
		}
		if (!moduleSkills.isRegistered) {
			this.$store.registerModule("moduleSkills", moduleSkills);
			moduleSkills.isRegistered = true;
		}
		if (!moduleTimeWindow.isRegistered) {
			this.$store.registerModule("moduleTimeWindow", moduleTimeWindow);
			moduleTimeWindow.isRegistered = true;
		}
		// Fetch to visit point service
		const id = parseInt(this.$route.params.id);
		this.openLoading();
		this.$store
			.dispatch("moduleVisitPoint/findVisitPointPaginated", {id: [id]})
			.then((res) => {
				this.visitPointData = res.records[0];
				this.closeLoading();
				return res.records;
			})
			.catch((err) => {
				this.closeLoading();
				if (err.status === 400) {
					this.vp_not_found = true;
					return;
				}
				console.error(err);
			});
	},
	beforeDestroy() {
		this.$store.commit("moduleCapacity/REMOVE_ALL_ASSIGNED_CAPACITY");
		this.$store.commit("moduleSkills/REMOVE_ALL_ASSIGNED_SKILL");
		this.$store.commit("moduleTimeWindow/REMOVE_ALL_ASSIGNED_TIME_WINDOW");
		this.$store.commit("frequency/REMOVE_ALL_ASSIGNED_FREQUENCY");
	},
};
</script>

<style lang="scss">
#avatar-col {
	width: 10rem;
}

#page-user-view {
	table {
		td {
			vertical-align: top;
			min-width: 140px;
			padding-bottom: 0.8rem;
			word-break: break-all;
		}

		&:not(.permissions-table) {
			td {
				@media screen and (max-width: 370px) {
					display: block;
				}
			}
		}
	}
}

@media screen and (min-width: 1201px) and (max-width: 1211px),
	only screen and (min-width: 636px) and (max-width: 991px) {
	#account-info-col-1 {
		width: calc(100% - 12rem) !important;
	}
}
</style>
